/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_TitleInputs */

const en_interview_title = /** @type {(inputs: Interview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interview Prep`)
};

const de_interview_title = /** @type {(inputs: Interview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorstellungsgespräch-Vorbereitung`)
};

const fr_interview_title = /** @type {(inputs: Interview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Préparation d'entretien`)
};

const es_interview_title = /** @type {(inputs: Interview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparación de entrevista`)
};

const it_interview_title = /** @type {(inputs: Interview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparazione al colloquio`)
};

const nl_interview_title = /** @type {(inputs: Interview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sollicitatiegespreksvoorbereiding`)
};

const pl_interview_title = /** @type {(inputs: Interview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przygotowanie do rozmowy kwalifikacyjnej`)
};

const fi_interview_title = /** @type {(inputs: Interview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haastatteluun valmistautuminen`)
};

const da_interview_title = /** @type {(inputs: Interview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interviewforberedelse`)
};

const sv_interview_title = /** @type {(inputs: Interview_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intervjuförberedelse`)
};

/**
* | output |
* | --- |
* | "Interview Prep" |
*
* @param {Interview_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_title = /** @type {((inputs?: Interview_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_title(inputs)
	if (locale === "fr") return fr_interview_title(inputs)
	if (locale === "es") return es_interview_title(inputs)
	if (locale === "it") return it_interview_title(inputs)
	if (locale === "nl") return nl_interview_title(inputs)
	if (locale === "pl") return pl_interview_title(inputs)
	if (locale === "fi") return fi_interview_title(inputs)
	if (locale === "da") return da_interview_title(inputs)
	if (locale === "sv") return sv_interview_title(inputs)
	return en_interview_title(inputs)
});